exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1wjJu{position:fixed;z-index:3008;background-color:rgba(50,50,50,.2);top:0;left:0;display:-webkit-box;display:-ms-flexbox;display:flex;overflow-y:auto;width:100%;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:400}.K6bxd{position:absolute;top:0;left:0;right:0;bottom:0;z-index:3009}._2R_Vs{position:relative;background-color:#fff;width:650px;min-height:510px;margin:5px;-ms-flex-item-align:center;align-self:center;z-index:3010;padding:10px 0}._1gpZK{display:none}@media screen and (max-width:480px){._1gpZK{margin-left:auto;display:block;padding:7px 7px 0 0;border:0;background-color:transparent}}", ""]);

// exports
exports.locals = {
	"Froot": "_1wjJu",
	"Fbg": "K6bxd",
	"Fcontainer": "_2R_Vs",
	"Fclose": "_1gpZK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/FondyFrame/FondyInvoiceContainer.css
// module id = 1435
// module chunks = 0 2 3 4 15 17 18 19 22 25 28 29 30 31 34 35 36 37 40